var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"blain-hover-card",style:({ padding: _vm.padding, borderRadius: _vm.borderRadius })},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }